<template>
  <div>
    <component :is="comName"></component>
    <!-- v-if="index >0&&index<=3" -->
    <videos paly="true"  v-if="comName=='datas'|| comName== 'distribution'||comName=='realTimes'"   class="videos right top20"></videos>
  </div>
</template>

<script>
import index from "./index.vue";
import distribution from "./distribution.vue";
import datas from "./datas.vue";
import realTimes from "./realTimes.vue";
import five from "./five.vue";
import videos from "./video.vue";
import { getAjsHeaderInfo } from "@/api/open";
import {getLibrary} from "@/api/study";
export default {
  data() {
    return {
      comName: "index",
      list: ["index", "distribution", "datas", "realTimes", "five"],
      // list: ["index", "distribution", "five"],
      index: 0,
      headerInfo: {},
      time:10,
      libraryInfo: {},
      libraryId: null,
      timer:null,
      upKeyTimer:null,
      play:false,
      oldComName:"index",
      indexTime:0
    };
  },
  components: {
    index,
    distribution,
    datas,
    realTimes,
    five,
    videos
  },
  created() {

    var _this=this;
    if (this.$route.query.libraryId) {
      this.libraryId = this.$route.query.libraryId;
    }
    this.oldComName = this.comName;
    if( sessionStorage.getItem('headerInfo')==null){
      this.comName=null;
      this.upHeaderInfo();
    }

    if( sessionStorage.getItem('libraryInfo')==null){
      this.comName=null;
      this. getLibraryInfo();
    }


     this.upKeyTimer =  setInterval(function(){
            getAjsHeaderInfo().then(response => {
            var headerInfo = response.data;

            sessionStorage.setItem('headerInfo',JSON.stringify(headerInfo));
          });
           getLibrary(_this.libraryId).then(response=>{
              var libraryInfo = response.data;

              sessionStorage.setItem('libraryInfo',JSON.stringify(libraryInfo));
            })
      },5*60*1000)


  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.upKeyTimer);

  },
  mounted() {

    console.log("参数", this.$route.query.automatic);
    if (this.$route.query.automatic == 1) {
    if (this.$route.query.time) {
      this.time = this.$route.query.time.split(',')

     var looptime = 0;
      for(var i=0;i< this.time.length;i++){
        looptime =looptime+ parseInt(this.time[i]) ;
      }
      console.log(this.time)
      var _this = this;
      _this.setTimefun()
       this.timer = setInterval(function(){
        _this.setTimefun()

      },looptime*1000)
     }
    } else {
      if (this.$route.query.address) {
          var _this = this;
          _this.comName = _this.$route.query.address;
          _this.list.forEach(function(item, i) {
            if (item == _this.$route.query.address) {
              _this.index = i;
            }
          });
      }
    }
   if(this.$route.query.showPage){
      this.list = this.$route.query.showPage.split(',');
      this.comName = this.list[0];
   }
  },
  methods: {
    setTimefun(){
      var exetime=0;
      var _this = this;
      for(var i=0;i<this.time.length;i++){
         exetime =exetime+ parseInt(this.time[i]);
         console.log(exetime)
         setTimeout(function(){
          _this.switchTo();
         },exetime*1000)
      }
    },
    switchTo() {
      var _this = this;
      if (_this.index < _this.list.length - 1) {
        _this.index = _this.index + 1;
      } else {
        _this.index = 0;
      }
      if(_this.index>0&&_this.index<=3){
        _this.play = true;
      }
      _this.comName = _this.list[_this.index];
      console.log(_this.comName);
      // if(_this.comName == 'index'){
      //   _this.comName = 'notice'
      // }else{
      //   _this.comName = 'index'
      // }
    }
  },
  upHeaderInfo() {
    getAjsHeaderInfo().then(response => {
      this.headerInfo = response.data;
      sessionStorage.setItem('headerInfo',JSON.stringify(this.headerInfo));
      this.comName = this.oldComName;
    });
  },
  getLibraryInfo(){
    getLibrary(this.libraryId).then(response=>{
      this.libraryInfo = response.data;
      sessionStorage.setItem('libraryInfo',JSON.stringify(this.libraryInfo));
      this.comName = this.oldComName;
    })
  },
};
</script>

<style>
.videos {
  position: absolute;
  right: 0;
  top: 120px;
}
.right {
  float: right;
  margin-right: 1%;
}
.top20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue